import axios from "axios";
import { IRefreshTokenResponse } from "../types/auth.types";
import { getRefreshToken } from "../utils/storage.utils";

/**
 * Refresh is a liveness check, not an AI call. A hung refresh used to leave
 * every later signed-in request sitting on a queue that never drained.
 * 20s is plenty for auth; do not raise this toward the 5-minute review cap.
 */
export const REFRESH_TIMEOUT_MS = 20_000;

/**
 * Refresh token — uses raw axios (not axiosInstance) to bypass the response
 * interceptor entirely. Reads API_BASE_URL from the build-time env var so
 * this module does NOT import axiosInstance, avoiding a circular dependency.
 */
export const refreshToken = async (): Promise<IRefreshTokenResponse> => {
  const token = await getRefreshToken();

  if (token == null) {
    return Promise.reject(new Error("No refresh token available"));
  }

  const baseURL = (process.env.API_BASE_URL ?? "").replace(/\/$/, "");
  const response = await axios.post<IRefreshTokenResponse>(
    `${baseURL}/auth/refresh`,
    { refresh_token: token },
    {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: REFRESH_TIMEOUT_MS,
    }
  );
  return response.data;
};
